import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdmin = location.pathname.startsWith("/admin");

  function linkClass(path: string) {
    const isActive = location.pathname === path;
    return `text-sm font-medium transition-colors duration-200 ${
      isActive ? "text-[#5716a8] font-semibold" : "text-[#1A1A1A]/60 hover:text-[#5716a8]"
    }`;
  }

  return (
    <nav className="bg-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center h-16 items-center">
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass("/")}>Home</Link>
            <Link to="/leaderboard" className={linkClass("/leaderboard")}>Winners</Link>
            <Link to={isAdmin ? "/admin/dashboard" : "/admin/login"} className={linkClass("/admin/login")}>
              {isAdmin ? "Dashboard" : "Admin"}
            </Link>
          </div>

          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-[#5716a8] p-2">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 pt-4 space-y-3 animate-slide-up text-center">
            <Link to="/" onClick={() => setMenuOpen(false)} className="block text-[#1A1A1A]/60 hover:text-[#5716a8] text-sm font-medium">Home</Link>
            <Link to="/leaderboard" onClick={() => setMenuOpen(false)} className="block text-[#1A1A1A]/60 hover:text-[#5716a8] text-sm font-medium">Winners</Link>
            <Link to={isAdmin ? "/admin/dashboard" : "/admin/login"} onClick={() => setMenuOpen(false)} className="block text-[#1A1A1A]/60 hover:text-[#5716a8] text-sm font-medium">
              {isAdmin ? "Dashboard" : "Admin"}
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
